// GSAP INIT
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({
	ease: "Power2.easeOut",
});

var options = {
    damping: 0.1,
    delegateTo: document,
};


ScrollTrigger.matchMedia({
	
  // Mobile & Tablet
  "(max-width: 800px)": function() {

// AUTOPLAY VIDEO ON SCROLL 
const videos = gsap.utils.toArray('video')

videos.forEach(function(video, i) {
    
ScrollTrigger.create({
	trigger: video,
	start: 'top 60%',
	end: 'bottom 40%',
	onEnter: () => video.play(),
	onEnterBack: () => video.play(),
	onLeave: () => video.pause(),
	onLeaveBack: () => video.pause(),
});
  
})	  

// gsap.to("video", {
// 	scrollTrigger: {
// 		trigger: "#video",
// 		start: "top center",
// 		end: "center center",
// 		toggleActions: "restart none none reverse",
// 		scrub: 0.2,
// 	},
// });


//HAMBURGER ICON ANIMATION
const hamburger = document.querySelector("#hamburger");

var ham = gsap.timeline({ paused: true });

ham.reverse();

// hamburger.addEventListener('click', () => {
// 	ham.reversed(!ham.reversed());
// });

$("#hamburger").click(function(){
  $(".nav-menu").toggleClass("active");
});
    return function() {
      
    };}
  
});




// let refs1 = gsap.to("#refs1", {
// xPercent: -40,
//   scrollTrigger: {
// 		trigger: ".referenties-images",
// 		start: "20% bottom",
// 		end: "120% top",
// 		toggleActions: "restart none none reverse",
// 		scrub: 0.9,
// 	},
// });

// let refs2 = gsap.to("#refs2", {
// xPercent: 60,
//   scrollTrigger: {
// 		trigger: ".referenties-images",
// 		start: "20% bottom",
// 		end: "120% top",
// 		toggleActions: "restart none none reverse",
// 		scrub: 0.9,
// 	},
// });
